import { ICategoryMenu } from '~/types/menu';

export const lifestyleEN: ICategoryMenu[] = [
  {
    title: 'New In',
    href: '/catalog/lifestyle',
    items: [
      {
        title: 'New In',
        href: '/catalog/lifestyle',
        items: [
          {
            title: 'HOME',
            href: '/catalog/lifestyle/home',
          },
          {
            title: 'StarGift',
            href: '/catalog/lifestyle/stargift',
          },
          {
            title: 'Devices',
            href: '/catalog/lifestyle/devices',
          },
        ],
      },
    ],
  },
  {
    title: 'Brands',
    href: '/brands/lifestyle',
    items: [
      {
        title: 'Brands',
        items: [
          {
            title: 'Hermes',
            href: '/catalog/hermes/lifestyle',
          },
          {
            title: 'Dyson',
            href: '/catalog/dyson/lifestyle',
          },
          {
            title: 'Kaws',
            href: '/catalog/kaws/lifestyle',
          },
          {
            title: 'Baccarat',
            href: '/catalog/baccarat/lifestyle',
          },
          {
            title: 'Daum',
            href: '/catalog/daum/lifestyle',
          },
          {
            title: 'Tiffany&Co',
            href: '/catalog/tiffanyco/lifestyle',
          },
          {
            title: 'Louis Vuitton',
            href: '/catalog/louis-vuitton/lifestyle',
          },
          {
            title: 'Versace',
            href: '/catalog/versace/lifestyle',
          },
        ],
      },
      {
        href: '/brands/lifestyle',
        items: [
          {
            title: 'Cartier',
            href: '/catalog/cartier/lifestyle',
          },
          {
            title: 'Gucci',
            href: '/catalog/gucci/lifestyle',
          },
          {
            title: 'Saint Louis',
            href: '/catalog/saintlouis/lifestyle',
          },
          {
            title: 'Lalique',
            href: '/catalog/lalique/lifestyle',
          },
          {
            title: 'Faberge',
            href: '/catalog/faberge/lifestyle',
          },
          {
            title: 'Villeroy&Boch',
            href: '/catalog/villeroyboch/lifestyle',
          },
        ],
      },
    ],
  },
  {
    title: 'Home',
    href: '/catalog/lifestyle/home',
    items: [
      {
        title: 'Home',
        href: '/catalog/lifestyle/home',
        items: [
          {
            title: 'Tableware',
            href: '/catalog/lifestyle/home/tableware',
          },
          {
            title: 'Interior Items',
            href: '/catalog/lifestyle/home/interior-items',
          },
          {
            title: 'Textile',
            href: '/catalog/lifestyle/home/textile',
          },
          {
            title: 'Flavors',
            href: '/catalog/lifestyle/home/flavors',
          },
          {
            title: 'Books',
            href: '/catalog/lifestyle/home/books',
          },
        ],
      },
    ],
  },
  {
    title: 'StarGift',
    href: '/catalog/lifestyle/stargift',
    items: [
      {
        title: 'StarGift',
        items: [
          {
            title: 'History',
            href: '/catalog/lifestyle/stargift/history',
          },
          {
            title: 'Movie',
            href: '/catalog/lifestyle/stargift/movie',
          },
          {
            title: 'Music',
            href: '/catalog/lifestyle/stargift/music',
          },
          {
            title: 'Sport',
            href: '/catalog/lifestyle/stargift/sport',
          },
          {
            title: 'Personal Addresses',
            href: '/catalog/lifestyle/stargift/personal-addresses',
          },
          {
            title: 'Exclusive',
            href: '/catalog/lifestyle/stargift/exclusive',
          },

        ],
      },
      {
        href: '/catalog/lifestyle/stargift',
        items: [
          {
            title: 'Meetings',
            href: '/catalog/lifestyle/stargift/meetings',
          },
          {
            title: 'New Products',
            href: '/catalog/lifestyle/stargift/new-products',
          },
          {
            title: 'Literature',
            href: '/catalog/lifestyle/stargift/literature',
          },
          {
            title: 'Politics',
            href: '/catalog/lifestyle/stargift/politics',
          },
          {
            title: 'Art',
            href: '/catalog/lifestyle/stargift/art',
          },
        ],
      },
    ],
  },
  {
    title: 'Devices',
    href: '/catalog/lifestyle/devices',
  },
];
